/**
 * @file
 * A JavaScript file for the theme.
 *
 */

(function (Drupal, $) {

  var event = (navigator.userAgent.match(/iPhone/i)) ? "touchstart" : "click";

  Drupal.behaviors.glpFloatingLabels = {
    attach: function (context) {

      function floatingLabels() {
        $select = $('.floating-labels select');

        // Apply classes on page load (and ajax refresh)
        $select.each(function() {
          if ($(this).prop('selectedIndex') === 0) {
            $(this).addClass('first-option-selected');
            $(this).removeClass('other-option-selected');
          } else {
            $(this).removeClass('first-option-selected');
            $(this).addClass('other-option-selected');
          }
        });

        $select.on('change', function() {
          // Check if the selected option is the first option (index 0)
          if ($(this).prop('selectedIndex') === 0) {
            $(this).removeClass('other-option-selected');
            $(this).addClass('first-option-selected');
          } else {
            $(this).removeClass('first-option-selected');
            $(this).addClass('other-option-selected');
          }
        });

      }

      floatingLabels();

      $( window ).on( "load", function( event) {
        // Add code here
      });

      $( window ).on( "load resize orientationchange", function( event ) {
        setTimeout(function( event ) {
          // Add code here
        }, 100);
      });

    }
  };

} (Drupal, jQuery));
